import baseUrl from "../../../../../utilities/baseUrl";
import axios from "axios";

export default function useMahexRate() {
  const mahexRate = async mahexData => {
    try {
      const mahexUrl = baseUrl + "/internalpost/v1/mahexRate";
      const token = localStorage.getItem("token");

      const mahexBody = {
        addressId: mahexData.SAddress,
        getterAddressId: mahexData.RAddress,
        method: mahexData.mahexType,
        value: mahexData.totalCost,
        weight: mahexData.totalWeightPayable,
        data: mahexData.rowsData,
        internalSectionId: 1,
        totalSpecialService: mahexData.totalSpecialService,
        needPrint: mahexData.needPrint,
        needSMS: mahexData.needSMS,
        needCollecting: mahexData.needCollecting,
        collectingType: 1,
        isCod: mahexData.isCod,
      };

      const result = await axios.request({
        method: "POST",
        url: mahexUrl,
        data: mahexBody,
        timeout: 18000,
        headers: {
          Authorization: "Bearer " + token,
        },
      });

      if (result.status === 200) {
        return {
          chaparData: result.data.result,
          Data: mahexData.mahexType,
        };
      }
    } catch (error) {
      return { Data: mahexData.mahexType, chaparData: { quote: 0 } };
    }
  };

  return { mahexRate };
}
